import { Icon } from '@iconify/react';

const CTASection = () => {
  const benefits = [
    { icon: 'mdi:clock-outline', text: 'Gratis 14 hari' },
    { icon: 'mdi:credit-card-outline', text: 'Tanpa kartu kredit' },
    { icon: 'mdi:cancel', text: 'Cancel kapan saja' },
    { icon: 'mdi:check-circle', text: 'Semua fitur premium' },
  ];

  return (
    <section className="py-20 md:py-28 gradient-hero relative overflow-hidden">
      {/* ===== BACKGROUND DECORATIONS ===== */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,rgba(255,255,255,0.1),transparent)]"></div>
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-20 -left-20 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>

      <div className="max-w-5xl mx-auto px-6 text-center relative z-10">
        {/* ===== BADGE ===== */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1.5 mb-6">
          <Icon icon="mdi:rocket" className="text-amber-400 text-sm" />
          <span className="text-xs font-medium text-white/90">Bergabunglah dengan 2,000+ perusahaan</span>
        </div>

        {/* ===== HEADING ===== */}
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
          Siap Transformasi Manajemen HR{' '}
          <br className="hidden sm:block" />
          Perusahaan Anda?
        </h2>

        {/* ===== DESCRIPTION ===== */}
        <p className="text-lg text-white/70 mb-8 max-w-2xl mx-auto leading-relaxed">
          Bergabung dengan 2,000+ perusahaan yang sudah mempercayai Zentra
          untuk mengelola SDM mereka dengan lebih cerdas, cepat, dan terukur.
        </p>

        {/* ===== BENEFITS (HORIZONTAL) ===== */}
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mb-10">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-center gap-2 text-sm text-white/80">
              <Icon icon={benefit.icon} className="text-emerald-400 text-lg" />
              <span>{benefit.text}</span>
            </div>
          ))}
        </div>

        {/* ===== CTA BUTTONS (SAMPING / HORIZONTAL) ===== */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button className="bg-white text-zentra-700 font-semibold px-8 py-4 rounded-xl text-sm hover:bg-gray-50 transition-all hover:shadow-xl hover:shadow-black/20 flex items-center gap-2">
            Daftar Gratis Sekarang
            <Icon icon="mdi:arrow-right" className="text-lg" />
          </button>
          <button className="bg-white/10 backdrop-blur-sm border border-white/20 text-white font-semibold px-8 py-4 rounded-xl text-sm hover:bg-white/20 transition-all flex items-center gap-2">
            <Icon icon="mdi:calendar" className="text-lg" />
            Jadwalkan Demo
          </button>
        </div>

        {/* ===== FOOTER TEXT ===== */}
        <p className="text-xs text-white/50 mt-6">
          Gratis 14 hari · Tanpa kartu kredit · Cancel kapan saja
        </p>

        {/* ===== SOCIAL PROOF ===== */}
        <div className="mt-8 flex items-center justify-center gap-6">
          <div className="flex -space-x-2">
            {[1, 2, 3, 4, 5].map((i) => (
              <img
                key={i}
                src={`https://picsum.photos/seed/cta${i}/40/40.jpg`}
                className="w-8 h-8 rounded-full border-2 border-white/30 object-cover"
                alt={`User ${i}`}
              />
            ))}
          </div>
          <div className="text-left">
            <div className="flex items-center gap-1">
              {[1, 2, 3, 4, 5].map((i) => (
                <Icon key={i} icon="mdi:star" className="text-amber-400 text-sm" />
              ))}
              <span className="text-xs font-semibold text-white ml-1">4.9/5</span>
            </div>
            <p className="text-xs text-white/60">Dari 500+ review pengguna</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
